// utils/constants.js
export const PAYMENT_TYPES = [
  { value: 'cash', label: '💵 Cash', icon: '💰' },
  { value: 'online', label: '💳 Online', icon: '📱' },
  { value: 'bank_transfer', label: '🏦 Bank Transfer', icon: '🏛️' },
  { value: 'cheque', label: '📝 Cheque', icon: '📄' },
];

export const PRIORITY_LEVELS = {
  high: { label: '🔴 High', color: 'red' },
  medium: { label: '🟡 Medium', color: 'yellow' },
  low: { label: '🟢 Low', color: 'green' },
};

export const PAYMENT_STATUS = {
  pending: { label: 'Pending', color: 'red' },
  partial: { label: 'Partial', color: 'yellow' },
  paid: { label: 'Paid', color: 'green' },
};

export const DELIVERY_STATUS = {
  pending: { label: 'Pending', color: 'yellow' },
  collected: { label: 'Collected', color: 'green' },
  overdue: { label: 'Overdue', color: 'red' },
};

export const API_BASE_URL = 'http://localhost:5000/api';

export const APP_NAME = 'Yantranity';
export const APP_VERSION = '1.0.0';

export const DEFAULT_PAGINATION = {
  page: 1,
  limit: 10,
};

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DISPLAY_DATE_FORMAT = 'DD MMM YYYY';